import React from 'react'
import Markdown from '../../parts/markdown'
import Stores from './store-buttons'
import Button from '../../parts/button'

const StoreBuySection = ({ pageContext, data, styling }) => {
  if(!data.buyGameSection) {
    return ''
  }

  const buyGameSectionData = data.buyGameSection
  const storesData = data.stores ? data.stores : null

  // Style the form with CSS classes
  const styles = {
    title: styling && styling.title ? styling.title : '',
    text: styling && styling.text ? styling.text : '',
    stores: styling && styling.stores ? styling.stores : '',
  }

  return (
    <>
      {buyGameSectionData.title &&
        <h2 className={`buy-game-title ${styles.title}`}>
          {buyGameSectionData.title}
        </h2>
      }
      {buyGameSectionData.text &&
        <Markdown
          children={buyGameSectionData.text}
          className={`buy-game-text ${styles.text}`}
        />
      }
      {buyGameSectionData.displayStores && storesData !== null &&
        <Stores
          id="buy-game-section"
          pageContext={pageContext}
          location="buyGameSection"
          stores={storesData}
          className={`buy-game-stores ${styles.stores}`}
        />
      }
      {buyGameSectionData.buttons && buyGameSectionData.buttons.map(button => (
        <Button
          id={button.buttonId}
          key={button.strapi_id}
          link={button.link ? button.link : '#'}
          trigger={button.trigger ? button.trigger : 'internalLink'}
          style={`${button.style ? button.style : null} hidden lg:flex`}
          icon={button.icon ? button.icon : null}
          pageContext={globalContext}
          eventCategory={button.eventCategory ? ctabuttonLink.eventCategory : ''}
          eventAction={button.eventAction ? button.eventAction : ''}
          eventType={button.eventCategory && button.eventCategory === 'buy' ? 'main' : 'form'}
          eventLocation='buy game section'
        >
          <Markdown children={button.label} />
        </Button>
      ))}
    </>
  )
}

export default StoreBuySection
